// extracted by mini-css-extract-plugin
export var searchHeader = "_89-0";
export var searchHeaderDark = "_89-1";